import React from "react";
import ServiceTestimonial from "../../../../components/ServiceTestimonial/ServiceTestimonial";
import HomeThreeSingleBlog from "../../../../components/HomeThreeSingleBlog/HomeThreeSingleBlog";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css/pagination";

SwiperCore.use([Navigation, Pagination]);

const ServicesTestimonialsTwo = () => {
  return (
    <>
      <section
        className="tp-testimonial-area-two tp-testimonial-area-four position-relative"
        style={{ background: "#fff8cc" }}
      >
        {/* <div className="tp-testimonial-area-two-shape" style={{background:"#d7d4d4"}}></div> */}
        {/* <div className="container position-relative">
               <div className="tp-testimonial-title-wrapper pt-20">
                  <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">Our Popular Services</h5>
                  <h2 className="tp-section-title heading-color-black">Business Champions</h2>
               </div>
            </div> */}

        <div className="pt-4">
          <h2 className="text-center tp-section-title heading-color-black">
            Business Champions
          </h2>
        </div>

        <div className="tp-testimonial-divide pt-30">
          <div className="tp-testimonial-two-wrapper z-index mb-0">
            <div className="tp-testimonial-two-active swiper-container common-dots pb-10 pl-10 pr-10">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                style={{ paddingBottom: "10px" }}
                className="swiper-wrapper"
                pagination={{ clickable: true }}
                pauseOnMouseEnter="true"
                autoplay={{ delay: 6000 }}
                breakpoints={{
                  550: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 4,
                  },
                }}
                navigation={{
                  nextEl: ".service-button-next",
                  prevEl: ".service-button-prev",
                }}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="5"
                    title="Shree Ganesh Services"
                    city="Mumbai"
                    namee="Mr. & Mrs. Singh"
                    linkk="https://youtu.be/M8vFGgiFmh0"
                    vIds="M8vFGgiFmh0"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="6"
                    title="Pawan Machineries Pvt. Ltd."
                    city="Mumbai"
                    namee="Mr. Bharat Vora"
                    linkk="https://www.youtube.com/watch?v=CI_H9neRJ2g"
                    vIds="CI_H9neRJ2g"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="7"
                    title="Vindhya E-Infomedia Pvt. Ltd."
                    city="Bangalore"
                    namee="Mrs. Pavithra YS"
                    linkk="https://www.youtube.com/watch?v=tqfBRIyh7AY​"
                    vIds="tqfBRIyh7AY"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="8"
                    title="Balaji Mithai Bandar"
                    city="Hyderabad"
                    namee="Mr. Shyam Shankala"
                    linkk="https://www.youtube.com/watch?v=5JTwdPI6nF8"
                    vIds="5JTwdPI6nF8"
                  />
                </SwiperSlide>
              </Swiper>

              <div className="swiper-pagination-testimonial slide-dots "></div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="tp-testimonial-area-two tp-testimonial-area-four position-relative"
        style={{ background: "rgb(231 230 220)" }}
      >
        {/* <div className="tp-testimonial-area-two-shape" style={{background:"#d7d4d4"}}></div> */}
        {/* <div className="container position-relative">
               <div className="tp-testimonial-title-wrapper pt-20">
                  <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">Our Popular Services</h5>
                  <h2 className="tp-section-title heading-color-black">Business Champions</h2>
               </div>
            </div> */}

        <div className=" pt-4">
          <h2 className="text-center tp-section-title ">Younite Partners</h2>
        </div>

        <div className="tp-testimonial-divide pt-30">
          <div className="tp-testimonial-two-wrapper z-index mb-0">
            <div className="tp-testimonial-two-active swiper-container common-dots pb-10 pl-10 pr-10">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                style={{ paddingBottom: "10px" }}
                className="swiper-wrapper"
                pagination={{ clickable: true }}
                pauseOnMouseEnter="true"
                autoplay={{ delay: 6000 }}
                breakpoints={{
                  550: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 4,
                  },
                }}
                navigation={{
                  nextEl: ".service-button-next",
                  prevEl: ".service-button-prev",
                }}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="25"
                    title="SK Smartech"
                    city="Bangalore"
                    namee="Mr. Arjun A Kalyam"
                    linkk="https://www.youtube.com/watch?v=PN_UJeedF2c"
                    vIds="PN_UJeedF2c"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="26"
                    title="Rashi Associates"
                    city="Bangalore"
                    namee="Mr. Vinod Kumar Tiwari"
                    linkk="https://www.youtube.com/watch?v=ZFA75G8gNng"
                    vIds="ZFA75G8gNng"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="27"
                    title="Cconnect Market India Pvt. Ltd."
                    city="Hyderabad"
                    namee="Mr. Sai Ram Raju"
                    linkk="https://www.youtube.com/watch?v=9DrFdNcLaNk"
                    vIds="9DrFdNcLaNk"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="28"
                    title="Star Powerz Human Resources Pvt. Ltd."
                    city="Hyderabad"
                    namee="Mr. Abburu Srikant"
                    linkk="https://www.youtube.com/watch?v=mMe38Oxf16k"
                    vIds="mMe38Oxf16k"
                  />
                </SwiperSlide>
              </Swiper>

              <div className="swiper-pagination-testimonial slide-dots "></div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="tp-testimonial-area-two tp-testimonial-area-four position-relative"
        style={{ background: "#fff8cc" }}
      >
        {/* <div className="tp-testimonial-area-two-shape" style={{background:"#d7d4d4"}}></div> */}
        {/* <div className="container position-relative">
               <div className="tp-testimonial-title-wrapper pt-20">
                  <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">Our Popular Services</h5>
                  <h2 className="tp-section-title heading-color-black">Business Champions</h2>
               </div>
            </div> */}

        <div className=" pt-4">
          <h2 className="text-center tp-section-title ">Employees Speak</h2>
        </div>

        <div className="tp-testimonial-divide pt-30">
          <div className="tp-testimonial-two-wrapper z-index mb-0">
            <div className="tp-testimonial-two-active swiper-container common-dots pb-10 pl-10 pr-10">
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                style={{ paddingBottom: "10px" }}
                className="swiper-wrapper"
                pagination={{ clickable: true }}
                pauseOnMouseEnter="true"
                autoplay={{ delay: 6000 }}
                breakpoints={{
                  550: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                  1200: {
                    slidesPerView: 4,
                  },
                }}
                navigation={{
                  nextEl: ".service-button-next",
                  prevEl: ".service-button-prev",
                }}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
              >
                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="15"
                    title="Regional Sales Manager"
                    city="Mumbai"
                    namee="Mr. Salman Patel"
                    linkk="https://www.youtube.com/watch?v=HfVwLiKbgIk"
                    vIds="HfVwLiKbgIk"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="16"
                    title="Sr. Manager L&D HR"
                    city="Mumbai"
                    namee="Ms. Papia Mishra"
                    linkk="https://www.youtube.com/watch?v=mJF2aHBU-7w"
                    vIds="mJF2aHBU-7w"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="17"
                    title="Regional Sales Manager"
                    city="Bangalore"
                    namee="Mr. Srinivas V"
                    linkk="https://www.youtube.com/watch?v=MGxWfyoHO2g"
                    vIds="MGxWfyoHO2g"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <HomeThreeSingleBlog
                    image_num="18"
                    title="Cluster Manager, Sales"
                    city="Hyderabad"
                    namee="Mr. Devarakonda Kishore"
                    linkk="https://www.youtube.com/watch?v=1CHQUShViC4&t=3s​​​"
                    vIds="1CHQUShViC4"
                  />
                </SwiperSlide>
              </Swiper>

              <div className="swiper-pagination-testimonial slide-dots "></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesTestimonialsTwo;
